import React, { ReactElement } from 'react';

type AboutProps = {
  country: string;
};

const About = ({ country }: AboutProps): ReactElement => {
  return (
    <section className="freight-forwarder-landing__about">
      <div className='container'>
        <div className="freight-forwarder-landing__about-overlay">
          <div className="freight-forwarder-landing__about-content">
            <h3 className="freight-forwarder-landing__about-title">
              Freight Forwarding Business and Tax Registration in {country}
            </h3>
            <p className="freight-forwarder-landing__about-paragraph">
              Begin your venture by officially registering your business entity in {country}.
              This registration process involves obtaining a unique company identification number,
              which you will use in all official documents and transactions. Additionally, register
              with the relevant tax authorities to enable you to conduct business within the legal
              frameworks of {country}.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
